import DialogZoom from '~/components/dialog/zoom/DialogZoom.vue';
export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.hook('app:created', async () => {
    const dialog = useDialogStore();
    window.addEventListener('click', (e) => {
      const element = e.target as HTMLElement;
      if (element.getAttribute && element.getAttribute('data-zoom-src')) {
        let src = element.getAttribute('data-zoom-src');
        // TODO use data-zoom-src
        src = element.getAttribute('src');
        dialog.open(DialogZoom, {
          src,
        });
      }
    });
  });
});
